import useSingleSetting from "../data/useSingleSetting";
import { IVehicle } from "../models/Vehicle";

const STOCK_NUMBER_VAT_KEY = "Vehicle:StockNumberVat";

const VAT_PAID_CHARACTER = "P";
const VAT_NOT_PAID_CHARACTER = "N";

export default function useStockNumber() {
  const { singleSetting } = useSingleSetting(STOCK_NUMBER_VAT_KEY);

  const useVatCharacter = singleSetting.data?.data?.value?.toLowerCase() === "true";

  // Appends the VAT character (P = paid, N = not paid) to a vehicle's stock number,
  // but only when the Vehicle:StockNumberVat setting is enabled. The character is
  // derived from the vehicle's ApplyVAT field (the source of truth; leads mirror it).
  const getStockNumber = (
    vehicle: IVehicle | null | undefined
  ): string | null => {
    const stockNumber = vehicle?.stockNumber ?? null;

    if (!stockNumber || !useVatCharacter) {
      return stockNumber;
    }

    // Fall back to the lead mirror for partially-populated vehicle objects.
    const vatApplied =
      vehicle?.applyVAT ?? vehicle?.leads?.[0]?.applyVAT ?? false;

    return `${stockNumber}${vatApplied ? VAT_PAID_CHARACTER : VAT_NOT_PAID_CHARACTER}`;
  };

  return {
    getStockNumber,
    useVatCharacter,
  };
}
